import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from "@angular/core";

@Component({
  selector: "ui-skeleton-line",
  templateUrl: "skeleton-line.component.html",
  styleUrls: ["skeleton-line.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ant-skeleton",
    "[class.ant-skeleton-active]": `uiActive`,
  },
  standalone: true,
})
export class UiSkeletonLineComponent {
  @Input({ transform: booleanAttribute }) public uiActive = false;
}
